import MealItem from './MealItem';

export default MealItem;
